<template>
    <div>
        <el-dialog :title="'号码详情'" :visible.sync="visible" width="60%" :before-close="handleClose" destroy-on-close
            :close-on-click-modal="false">
            <el-form :model="dataForm" ref="dataForm" label-width="110px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机号码：" prop="Phone">
                            <span v-if="dataForm.Phone">{{ dataForm.Phone }}</span>
                        </el-form-item>

                        <el-form-item label="套餐名称：" prop="PlanName">
                            <span v-if="dataForm.PlanName">{{ dataForm.PlanName }}</span>
                        </el-form-item>

                        <el-form-item label="号码归属地：" prop="NumberAttribution">
                            <span v-if="dataForm.NumberAttribution">{{ dataForm.NumberAttribution }}</span>
                        </el-form-item>

                        <el-form-item label="总流量：" prop="TotalData">
                            <span v-if="dataForm.TotalData">{{ dataForm.TotalData }}MB</span>
                        </el-form-item>

                        <el-form-item label="剩余流量：" prop="UnusedData">
                            <span v-if="dataForm.UnusedData">{{ dataForm.UnusedData }}MB</span>
                        </el-form-item>

                        <el-form-item label="已用流量：" prop="UsedData">
                            <span v-if="dataForm.UsedData">{{ dataForm.UsedData }}MB</span>
                        </el-form-item>

                        <el-form-item label="已用话费：" prop="UsedAmount">
                            <span v-if="dataForm.UsedAmount">{{ dataForm.UsedAmount }}元</span>
                        </el-form-item>

                        <el-form-item label="话费余额：" prop="Amount" v-permission="['/Card/NumberCard/Amount']">
                            <span v-if="dataForm.Amount">{{ dataForm.Amount }}元</span>
                        </el-form-item>

                        <el-form-item label="话费欠费金额：" prop="OwedAmount">
                            <span v-if="dataForm.OwedAmount">{{ dataForm.OwedAmount }}元</span>
                        </el-form-item>

                        <el-form-item label="网络运营商：" prop="Net">
                            <span v-if="dataForm.Net">{{ dataForm.Net }}</span>
                        </el-form-item>

                        <el-form-item label="用户状态：" prop="UserStatus">
                            <span v-if="dataForm.UserStatus">{{ dataForm.UserStatus }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="开关机状态：" prop="StopOpenStatus">
                            <span v-if="dataForm.StopOpenStatus">{{ dataForm.StopOpenStatus }}</span>
                        </el-form-item>

                        <el-form-item label="总短信数：" prop="TotalMsg">
                            <span v-if="dataForm.TotalMsg">{{ dataForm.TotalMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="已用短信数：" prop="UsedMsg">
                            <span v-if="dataForm.UsedMsg">{{ dataForm.UsedMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="剩余短信数：" prop="UnusedMsg">
                            <span v-if="dataForm.UnusedMsg">{{ dataForm.UnusedMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="总彩信数：" prop="TotalMMsg">
                            <span v-if="dataForm.TotalMMsg">{{ dataForm.TotalMMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="已用彩信数：" prop="UsedMMsg">
                            <span v-if="dataForm.UsedMMsg">{{ dataForm.UsedMMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="剩余彩信数：" prop="UnusedMMsg">
                            <span v-if="dataForm.UnusedMMsg">{{ dataForm.UnusedMMsg }}条</span>
                        </el-form-item>

                        <el-form-item label="总通话时间：" prop="TotalCallTime">
                            <span v-if="dataForm.TotalCallTime">{{ dataForm.TotalCallTime }}分钟</span>
                        </el-form-item>

                        <el-form-item label="已用通话时间：" prop="UsedCallTime">
                            <span v-if="dataForm.UsedCallTime">{{ dataForm.UsedCallTime }}分钟</span>
                        </el-form-item>

                        <el-form-item label="剩余通话时间：" prop="UnusedCallTime">
                            <span v-if="dataForm.UnusedCallTime">{{ dataForm.UnusedCallTime }}分钟</span>
                        </el-form-item>
                        <el-form-item label="激活时间：" prop="ActiveTime">
                            <span v-if="dataForm.ActiveTime">{{ dataForm.ActiveTime }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            dataForm: {
                Phone: "",
                PlanName: "",
                NumberAttribution: "",
                TotalData: "",
                UnusedData: "",
                UsedData: "",
                UsedAmount: "",
                Amount: "",
                OwedAmount: "",
                Net: "",
                UserStatus: "",
                StopOpenStatus: "",
                TotalMsg: "",
                UsedMsg: "",
                UnusedMsg: "",
                TotalMMsg: "",
                UsedMMsg: "",
                UnusedMMsg: "",
                TotalCallTime: "",
                UsedCallTime: "",
                UnusedCallTime: ""
            }
        };
    },
    methods: {
        init(tel) {
            this.visible = true;
            for (let key in this.dataForm) {
                this.dataForm[key] = "";
            }
            let phones = [];
            if (tel) {
                phones.push(tel); // 确保这是一个字符串数组
                this.$http({
                    url: "/api/FilterCaller/QueryTelInfo",
                    method: "post",
                    data: phones // 直接发送电话号码数组
                }).then((res) => {
                    this.$nextTick(() => {
                        console.log(res)
                        this.dataForm.Phone = res.data.response[0].Phone;
                        this.dataForm.PlanName = res.data.response[0].PlanName;
                        this.dataForm.NumberAttribution = res.data.response[0].NumberAttribution;
                        this.dataForm.TotalData = res.data.response[0].TotalData;
                        this.dataForm.UnusedData = res.data.response[0].UnusedData;
                        this.dataForm.UsedData = res.data.response[0].UsedData;
                        this.dataForm.UsedAmount = res.data.response[0].UsedAmount;
                        this.dataForm.Amount = res.data.response[0].Amount;
                        this.dataForm.OwedAmount = res.data.response[0].OwedAmount;
                        this.dataForm.Net = res.data.response[0].Net;
                        this.dataForm.UserStatus = res.data.response[0].UserStatus;
                        this.dataForm.StopOpenStatus = res.data.response[0].StopOpenStatus;
                        this.dataForm.TotalMsg = res.data.response[0].TotalMsg;
                        this.dataForm.UsedMsg = res.data.response[0].UsedMsg;
                        this.dataForm.UnusedMsg = res.data.response[0].UnusedMsg;
                        this.dataForm.TotalMMsg = res.data.response[0].TotalMMsg;
                        this.dataForm.UsedMMsg = res.data.response[0].UsedMMsg;
                        this.dataForm.UnusedMMsg = res.data.response[0].UnusedMMsg;
                        this.dataForm.TotalCallTime = res.data.response[0].TotalCallTime;
                        this.dataForm.UsedCallTime = res.data.response[0].UsedCallTime;
                        this.dataForm.UnusedCallTime = res.data.response[0].UnusedCallTime;
                        this.dataForm.ActiveTime = res.data.response[0].ActiveTime;
                    });
                });
            }
        },

        handleClose() {
            this.visible = false;
        },
    },
};
</script>

<style></style>